import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "./ui-kit";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center"><Spinner /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "super_admin" ? "/admin" : "/app"} replace />;
  }
  return children;
}

export default ProtectedRoute;
